import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f35b9d9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "campaign-body-container"
};
const _hoisted_2 = {
  class: "ba-weekly-body-left"
};
const _hoisted_3 = {
  class: "ba-weekly-body-left-item"
};
const _hoisted_4 = {
  class: "left-item-title-box"
};
const _hoisted_5 = {
  class: "info-box"
};
const _hoisted_6 = {
  style: {
    "color": "#F07A80"
  },
  class: "info-box-item"
};
const _hoisted_7 = {
  style: {
    "width": "4px",
    "height": "4px",
    "aspect-ratio": "1/1",
    "border-radius": "4px",
    "background": "#B7BDC2"
  }
};
const _hoisted_8 = {
  style: {
    "color": "#22863D"
  },
  class: "info-box-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "100%", -1));
const _hoisted_10 = {
  class: "ba-weekly-body-left-item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-item-title-box"
}, " % of max potential ", -1));
const _hoisted_12 = {
  class: "ba-weekly-body-right"
};
const _hoisted_13 = {
  class: "ba-weekly-body-right-item"
};
const _hoisted_14 = {
  class: "right-item-title-box"
};
const _hoisted_15 = {
  class: "ba-weekly-body-right-item"
};
const _hoisted_16 = {
  class: "right-item-title-box"
};
const _hoisted_17 = {
  class: "right-item-text-box",
  style: {
    "color": "#71777F"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_ppc_budget_allocation_weekly_budget_input = _resolveComponent("ppc-budget-allocation-weekly-budget-input");
  const _component_BarChartIcon = _resolveComponent("BarChartIcon");
  const _component_CalendarWithArrowLeftIcon = _resolveComponent("CalendarWithArrowLeftIcon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" Weekly budget "), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, _toDisplayString($options.validation.type), 1), _createVNode(_component_app_icon, {
    icon: "arrow-right",
    color: "#F07A80",
    size: 10,
    style: {
      "margin": "auto 0"
    }
  }), _createVNode(_component_currency_value, {
    value: $options.validation.value,
    currency: $props.currency,
    precision: 0,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency"])], 512), [[_vShow, $options.validation.status === 'error']]), _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [[_vShow, $options.validation.status === 'error']]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_app_icon, {
    icon: "arrow-right",
    color: "#22863D",
    size: 10,
    style: {
      "margin": "auto 0"
    }
  }), _createVNode(_component_currency_value, {
    value: $props.data.budgetPotential,
    currency: $props.currency,
    precision: 0,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency"])])])]), _createVNode(_component_ppc_budget_allocation_weekly_budget_input, {
    modelValue: $data.localModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.localModel = $event),
    ai: $props.data.budgetAi,
    currency: $props.currency,
    country_code: $props.country_code,
    focus: $props.open,
    advanced: $props.advanced,
    onInputUpdate: $options.onInputUpdateBudget
  }, null, 8, ["modelValue", "ai", "currency", "country_code", "focus", "advanced", "onInputUpdate"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_ppc_budget_allocation_weekly_budget_input, {
    modelValue: $data.localModelPotential,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.localModelPotential = $event),
    ai: ($props.data.budgetAi / $props.data.budgetPotential ?? 1) * 100,
    currency: $props.currency,
    country_code: $props.country_code,
    focus: $props.open,
    onInputUpdate: $options.onInputUpdatePotential,
    percentage: ""
  }, null, 8, ["modelValue", "ai", "currency", "country_code", "focus", "onInputUpdate"])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_BarChartIcon), _createTextVNode(" EVOLUTION ")]), _createElementVNode("div", {
    class: _normalizeClass(["right-item-text-box ba-text", {
      'ba-text-red': $props.data.evolution < 0,
      'ba-text-green': $props.data.evolution > 0
    }])
  }, [_createVNode(_component_currency_value, {
    value: $props.data.evolution,
    currency: $props.currency,
    precision: 0,
    allowPrecisionModification: false,
    showSign: ""
  }, null, 8, ["value", "currency"])], 2)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_CalendarWithArrowLeftIcon), _createTextVNode(" LAST WEEK ")]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_currency_value, {
    value: $props.data.previous_week_spend,
    currency: $props.currency,
    precision: 0,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency"])])])])]);
}